export const IconList = (() => {
	'use strict';

	function init() {

		
		
		var $orbs = $('.list .orb-holder .orb-parallax');

		// // orb parallax //
		// if($orbs.length) {

		// 	$(window).on("load scroll", function() {

		// 		window.requestAnimationFrame(function() {

		// 			var windowTop = $(window).scrollTop();

		// 			$orbs.each(function(){

		// 				var elementTop = $(this).offset().top,
		// 				elementHeight = $(this).height(),
		// 				viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
		// 				scrolled = windowTop - elementTop + viewPortHeight,
		// 				ratio;

		// 				switch($(this).attr('class')){
		// 					case "orb orb--xsmall": 
		// 						ratio = -0.15;
		// 						break;
		// 					case "orb orb--small": 
		// 						ratio = -0.30;
		// 						break;
		// 					case "orb orb--medium": 
		// 						ratio = -0.45;
		// 						break;
		// 				}

		// 				$(this).css({
		// 					transform: "translate3d(0," + scrolled * ratio + "px, 0)"
		// 				});
		// 			})

		// 		});
		// 	});

		// } 

		function moveRandom(obj) {
		
		var topPos;
		var horPos;

		topPos = Math.floor(Math.random() * 90) + 1 + '%';
		horPos = Math.floor(Math.random() * 50) + 1 + '%';

		var leftObject = { 
			top: topPos,
			right: horPos
		  };
		
		var rightObject = { 
			top: topPos,
			right: horPos
		  };

		  if (obj.parent().hasClass('orbs__right')) {
			obj.css(rightObject);
		  }
		  
		  else {
			obj.css(leftObject);
		  }

		}

		$orbs.each(function() {
			moveRandom($(this));
			});	


	}

	

	return {
		init: init,
		name: 'icon-list'
	};
})();
